import { Container, Header } from '@/components'
import {
  BrandedForms,
  SmartForms,
  Responsive,
  Usage,
  Banner,
  Brand,
  Integrations,
  OpenSourceCTA,
  Cta,
  Testimonials
} from '@/components/home'
import { HomePageService } from '@/service'

const Home = ({ githubStars, userCount, testimonials }): JSX.Element => (
  <Container customHeader={<Header />}>
    <main>
      <Banner githubStars={githubStars} userCount={userCount} />
      <Brand />
      <BrandedForms />
      <SmartForms />
      <Responsive />
      <Usage />
      <Integrations />
      <OpenSourceCTA githubStars={githubStars} />
      <Testimonials testimonials={testimonials} />
      <Cta />
    </main>
  </Container>
)

export async function getServerSideProps(): Promise<unknown> {
  const [githubStars, userCount, testimonials] = await Promise.all([
    HomePageService.githubStars(),
    HomePageService.userCount(),
    HomePageService.testimonials()
  ])

  return {
    props: {
      githubStars,
      userCount,
      testimonials
    }
  }
}

export default Home
